import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../../../reducers';

import PlusWhiteIcon from '../../../../media/white_plus-small_icon.svg';
import Edit from '../../../../media/felsv/DarkEditPencil.svg'
import Recycle from '../../../../media/felsv/DarkRecycleDelete.svg'
import Open_Eye from '../../../../media/felsv/Open_Eye.svg'
import Close_Eye from '../../../../media/felsv/Close_Eye.svg'

import { useEffect, useState } from 'react';
import { actionsGUEstadoDocumentos } from '../../../../actions/action-creators';
import { bindActionCreators } from 'redux';
import { Tooltip } from '../../../../components/Tooltip/Tooltip';
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';

export const Sucursales = () => {
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionsGUEstadoDocumentos, dispatch);

  const {dataSucursales} = useSelector((state: State) => state.gestionUsuario.sucursales);
  const [currentSucursales, setCurrentSucursales] = useState<Array<any>>([]);
  const [sortedSucursales, setSortedSucursales] = useState<Array<any>>([])
  
  useEffect(() => {
    setSortedSucursales(dataSucursales)
  }, [dataSucursales])

  useEffect(() => {
    obtenerSucursales();
  }, []);

  const obtenerSucursales = () => {
    acciones.su_getSucursalesList();
  }

  const handleChangeEstatus = (sucursal: any, accion: boolean) => {
    acciones.gu_ed_SetDocumentoSeleccionado({...sucursal, accion, title: 'sucursal'});
    acciones.gu_ed_ShowModalChangeEstatus(true);
  }

  const handleAdd = () => {
    acciones.su_ClearFormSucursal();
    acciones.gu_ed_ShowModalCrearEditarDocumento(true);
  }

  const handleEdit = (sucursal: any) => {
    acciones.su_setFormSucursal({...sucursal, mode:"edit"});
    acciones.gu_ed_ShowModalCrearEditarDocumento(true);
  }

  const handleDelete = (sucursal: any) => {
    acciones.gu_ed_SetDocumentoSeleccionado({...sucursal, title: "sucursal"});
    acciones.gu_ed_ShowModalEliminarDocumento(true)
  }

  return (
    <div className='container-white w-100'>
      <div className='card-basic w-100 mt-16'>
        <div className='mb-16'>
          <h3 className='card-title l mb-16'>Sucursales</h3>
          <div className='w-100 flex-align-end'>
            <button 
              className='m button w-auto' 
              style={{display: 'right'}} 
              onClick={handleAdd}
            >
              {
                (<>
                  <img src={PlusWhiteIcon} loading='lazy' alt=''/>
                  <div>{'Agregar sucursal'}</div>
                </>)
              }
            </button>
          </div>
          <div className='separador' style={{opacity: '10%', marginTop: '16px'}}></div>
        </div>
        <div>
          <div className='tab-plane'>
            <table className='table-main-responsive responsive-table-main td-left table-pointer'>
              <thead>
                <tr>
                  <td>Nombre de sucursal <FilterButton data={sortedSucursales} keyName='nombre' state={(items: Array<any>) => setSortedSucursales(items)}/></td>
                  <td>Código <FilterButton data={sortedSucursales} keyName='codigo' state={(items: Array<any>) => setSortedSucursales(items)}/></td>
                  <td>Dirección <FilterButton data={sortedSucursales} keyName='direccion' state={(items: Array<any>) => setSortedSucursales(items)}/></td>
                  <td>Descripción <FilterButton data={sortedSucursales} keyName='descripcion' state={(items: Array<any>) => setSortedSucursales(items)}/></td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {
                  currentSucursales.map((sucursal, index) => (
                    <tr key={index} style={{opacity: (!sucursal.activo ? '0.5' : '1')}}>
                      <td data-label='Nombre de sucursal'>{sucursal.nombre}</td>
                      <td data-label='Código'>{sucursal.codigo}</td>
                      <td data-label='Dirección'>{sucursal.direccion}</td>
                      <td data-label='Descripción'>{sucursal.descripcion}</td>
                      <td data-label='Acciones' className='table-td'>
                        <Tooltip content={sucursal.activo ? 'Desactivar' : 'Activar'}>
                          <button className='table-action' onClick={() => handleChangeEstatus(sucursal, !sucursal.activo)}>
                            <img src={sucursal.activo ? Open_Eye : Close_Eye} alt={sucursal.activo ? 'Desactivar' : 'Activar'} className='table-img-action' />
                          </button>
                        </Tooltip>
                        {
                          sucursal.eliminar &&
                            <Tooltip content='Editar'>
                              <button className='table-action' onClick={() => handleEdit(sucursal)}>
                                <img src={Edit} alt='Editar' className='table-img-action' />
                              </button>
                            </Tooltip>
                        }
                        {
                            sucursal.eliminar &&
                              <Tooltip content='Eliminar'>
                              <button className='table-action' onClick={() => handleDelete(sucursal)}>
                                <img src={Recycle} alt='Eliminar sucursal' className='table-img-action' />
                              </button>
                              </Tooltip>
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            <Pagination data={sortedSucursales} state={(items: Array<any>) => setCurrentSucursales(items)} items={15} />
          </div>
        </div> 
      </div>
    </div>
  )
}
